"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const splide_1 = __importDefault(require("@splidejs/splide"));
require("@splidejs/splide/src/css/core/index.scss");
require("@splidejs/splide/src/css/template/default/index.scss");
require("@splidejs/splide/src/css/themes/default/index.scss");
const localize_1 = require("./modules/localize");
const sliderElements = Array.from(document.querySelectorAll('.gs1-slider'));
const multiColumnSliders = Array.from(document.querySelectorAll('.gs1-slider--multicolumn'));
if (sliderElements || multiColumnSliders) {
    const slides = document.querySelector('[data-splide-slider-tracker]');
    let slidesTracker = '';
    if (slides) {
        slidesTracker = slides.getAttribute('data-splide-slider-tracker');
    }
    document.addEventListener('DOMContentLoaded', function () {
        if (sliderElements && slidesTracker !== '1') {
            sliderElements.forEach((item) => {
                let sliderOptions = {
                    type: 'loop',
                    rewind: true,
                    width: '100%',
                    height: 'max-content',
                    start: 0,
                    perPage: 1,
                    arrows: true,
                    pagination: false,
                    autoplay: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    lazyLoad: 'nearby',
                    preloadPages: 2,
                    keyboard: true,
                    direction: 'ltr',
                    breakpoints: {
                        480: {
                            perPage: 1,
                            height: 'max-content',
                        },
                    },
                    i18n: {
                        'prev': `${(0, localize_1.Localize)('element.label.slider.prev', 'Previous')}`,
                        'next': `${(0, localize_1.Localize)('element.label.slider.next', 'Next')}`,
                        'first': `${(0, localize_1.Localize)('element.label.slider.first', 'First')}`,
                        'last': `${(0, localize_1.Localize)('element.label.slider.last', 'Next')}`,
                        'slideX': `${(0, localize_1.Localize)('element.label.slider.slideX', 'Slide')}`,
                        'pageX': `${(0, localize_1.Localize)('element.label.slider.pageX', 'Page')}`,
                        'play': `${(0, localize_1.Localize)('element.label.slider.play', 'Play')}`,
                        'pause': `${(0, localize_1.Localize)('element.label.slider.pause', 'Pause')}`,
                        'carousel': `${(0, localize_1.Localize)('element.label.slider.carousel', 'Carousel')}`,
                        'select': `${(0, localize_1.Localize)('element.label.slider.select', 'Select slide to show')}`,
                        'slide': `${(0, localize_1.Localize)('element.label.slider.slide', 'Slide')}`,
                        'slideLabel': `${(0, localize_1.Localize)('element.label.slider.slideLabel', 'Slide %s of %s')}`,
                    }
                };
                // Check if autoslide is active and toggle options object accordingly.
                if (item.getAttribute('data-gs1-slider-autoslide') === '1') {
                    sliderOptions = {
                        type: 'loop',
                        rewind: true,
                        width: '100%',
                        height: 'max-content',
                        start: 0,
                        perPage: 1,
                        arrows: true,
                        pagination: false,
                        autoplay: true,
                        interval: item.getAttribute('data-gs1-slider-interval'),
                        pauseOnHover: true,
                        pauseOnFocus: true,
                        lazyLoad: 'nearby',
                        preloadPages: 2,
                        keyboard: true,
                        direction: 'ltr',
                        breakpoints: {
                            480: {
                                perPage: 1,
                                height: 'max-content',
                            },
                        },
                        i18n: {
                            'prev': `${(0, localize_1.Localize)('element.label.slider.prev', 'Previous')}`,
                            'next': `${(0, localize_1.Localize)('element.label.slider.next', 'Next')}`,
                            'first': `${(0, localize_1.Localize)('element.label.slider.first', 'First')}`,
                            'last': `${(0, localize_1.Localize)('element.label.slider.last', 'Next')}`,
                            'slideX': `${(0, localize_1.Localize)('element.label.slider.slideX', 'Slide')}`,
                            'pageX': `${(0, localize_1.Localize)('element.label.slider.pageX', 'Page')}`,
                            'play': `${(0, localize_1.Localize)('element.label.slider.play', 'Play')}`,
                            'pause': `${(0, localize_1.Localize)('element.label.slider.pause', 'Pause')}`,
                            'carousel': `${(0, localize_1.Localize)('element.label.slider.carousel', 'Carousel')}`,
                            'select': `${(0, localize_1.Localize)('element.label.slider.select', 'Select slide to show')}`,
                            'slide': `${(0, localize_1.Localize)('element.label.slider.slide', 'Slide')}`,
                            'slideLabel': `${(0, localize_1.Localize)('element.label.slider.slideLabel', 'Slide %s of %s')}`,
                        }
                    };
                }
                new splide_1.default(item, sliderOptions).mount();
            });
            if (multiColumnSliders) {
                multiColumnSliders.forEach((item) => {
                    new splide_1.default(item, {
                        type: 'fade',
                        rewind: true,
                        width: '100%',
                        height: 'max-content',
                        pagination: false,
                        autoplay: true,
                        pauseOnHover: true,
                        pauseOnFocus: true,
                        lazyLoad: 'nearby',
                        direction: 'ltr',
                        arrows: true,
                        perPage: 4,
                        gap: '1.87rem',
                        breakpoints: {
                            640: {
                                perPage: 2,
                                gap: '1.87rem',
                                height: '10rem',
                            },
                            480: {
                                perPage: 1,
                                gap: '1.87rem',
                                height: '9.37rem',
                            },
                        },
                    }).mount();
                });
            }
        }
        if (sliderElements && slidesTracker === '1') {
            sliderElements.forEach((item) => {
                new splide_1.default(item, {
                    type: 'fade',
                    rewind: true,
                    width: '100%',
                    height: 'max-content',
                    start: 0,
                    perPage: 1,
                    arrows: false,
                    pagination: false,
                    autoplay: true,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    lazyLoad: 'nearby',
                    preloadPages: 2,
                    keyboard: true,
                    direction: 'ltr',
                    breakpoints: {
                        480: {
                            perPage: 1,
                            height: 'unset',
                        },
                    },
                    i18n: {
                        'prev': `${(0, localize_1.Localize)('element.label.slider.prev', 'Previous')}`,
                        'next': `${(0, localize_1.Localize)('element.label.slider.next', 'Next')}`,
                        'first': `${(0, localize_1.Localize)('element.label.slider.first', 'First')}`,
                        'last': `${(0, localize_1.Localize)('element.label.slider.last', 'Next')}`,
                        'slideX': `${(0, localize_1.Localize)('element.label.slider.slideX', 'Slide')}`,
                        'pageX': `${(0, localize_1.Localize)('element.label.slider.pageX', 'Page')}`,
                        'play': `${(0, localize_1.Localize)('element.label.slider.play', 'Play')}`,
                        'pause': `${(0, localize_1.Localize)('element.label.slider.pause', 'Pause')}`,
                        'carousel': `${(0, localize_1.Localize)('element.label.slider.carousel', 'Carousel')}`,
                        'select': `${(0, localize_1.Localize)('element.label.slider.select', 'Select slide to show')}`,
                        'slide': `${(0, localize_1.Localize)('element.label.slider.slide', 'Slide')}`,
                        'slideLabel': `${(0, localize_1.Localize)('element.label.slider.slideLabel', 'Slide %s of %s')}`,
                    }
                }).mount();
            });
        }
    });
}
